import React from 'react';
import { Section } from './ui/Section';
export function ProblemReframe() {
  return <Section className="text-center" data-id="element-562">
      <div className="max-w-3xl mx-auto" data-id="element-563">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-564">
          La hinchazón no es solo molesta.
          <br data-id="element-565" />
          <span className="text-[#2D5016]" data-id="element-566">
            Está frenando tu mejor versión.
          </span>
        </h2>
        <p className="text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-567">
          Imagina despertarte sin esa sensación de pesadez. Ponerte tus
          pantalones favoritos sin luchar con el botón. Sentirte ligero, ágil y
          listo para disfrutar de tus nietos, tus hobbies y tu vida.
        </p>
        <div className="h-1 w-24 bg-[#D4AF37] mx-auto rounded-full" data-id="element-568"></div>
      </div>
    </Section>;
}